import { goToStation } from '@/lib/navigation';
import { useReducedMotionSync } from '@/lib/useReducedMotion';
import { stations, useTourStore } from '@/state/tour';
import { ChapterPanel } from './ChapterPanel';
import { Header } from './Header';
import { StationPanel } from './StationPanel';

export function Overlay() {
  useReducedMotionSync();
  const activeIndex = useTourStore((s) => s.activeIndex);
  const progress = useTourStore((s) => s.progress);
  const hovered = useTourStore((s) => s.hovered);
  const ready = useTourStore((s) => s.ready);
  const active = stations[activeIndex]!;

  return (
    <>
      <div className="progress" style={{ width: `${progress * 100}%` }} aria-hidden />
      <div className="loader" data-done={ready} role="status">
        loading…
      </div>
      <div className="overlay">
        <Header />

        <div className="middle">
          <ChapterPanel station={active} />
          <StationPanel />
        </div>

        <footer className="footer">
          <nav className="dots" aria-label="Tour stations">
            {stations.map((s, i) => (
              <button
                key={s.id}
                className="dot"
                aria-label={s.title}
                aria-current={i === activeIndex}
                onClick={() => goToStation(i)}
              />
            ))}
          </nav>
          <span className="hint">scroll · ← → · click a dot</span>
        </footer>
      </div>

      {hovered && (
        <div className="tooltip" style={{ left: hovered.x, top: hovered.y }}>
          {hovered.type}
          {hovered.name ? ` · ${hovered.name}` : ''}
        </div>
      )}
    </>
  );
}
